import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import DiscountService from "../../../Services/QRCodeServices/DiscountService/DiscountService";
import {
  Card,
  CardBody,
  CardTitle,
  CardText,
  Spinner,
  Alert,
  Container,
  Row,
  Col,
  Badge,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

export const DiscountDetail = () => {
  const { id } = useParams(); // Get the discount ID from the URL
  const [discount, setDiscount] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDiscountDetails = async () => {
      try {
        setLoading(true);
        const response = await DiscountService.detail(id);
        setDiscount(response);
        setError(null);
      } catch (err) {
        setError("Failed to fetch discount details");
        console.error("Error fetching discount details:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDiscountDetails();
  }, [id]);

  if (loading) {
    return (
      <Container className="mt-5">
        <Row className="justify-content-center">
          <Col md="6" className="text-center">
            <Spinner color="primary" />
            <p>Loading...</p>
          </Col>
        </Row>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="mt-5">
        <Row className="justify-content-center">
          <Col md="6">
            <Alert color="danger">{error}</Alert>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          pageTitle="Discount Offer Detail"
          title="Discount Offer"
          breadcrumbItems={[
            { title: "Back To List ", link: "/discount-offer" },
          ]}
        />
        <Row className="justify-content-center">
          <Col md="8">
            <Card className="shadow-sm right ribbon-box">
              <CardBody>
                <CardTitle tag="h2" className="text-center mb-4">
                  Discount Details
                </CardTitle>
                <div className="ribbon-two ribbon-two-primary">
                  <span className="text-white">
                    {discount.discountPercentage}% OFF
                  </span>
                </div>
                <Row>
                  {/* Left Column */}
                  <Col md="6">
                    <CardText>
                      <strong>Title:</strong> {discount.title}
                    </CardText>
                    <CardText>
                      <strong>Description:</strong> {discount.description}
                    </CardText>
                    <CardText>
                      <strong>Start Date:</strong>{" "}
                      {new Date(discount.startDate).toLocaleDateString()}
                    </CardText>
                  </Col>
                  {/* Right Column */}
                  <Col md="6">
                    <CardText>
                      <strong>End Date:</strong>{" "}
                      {new Date(discount.endDate).toLocaleDateString()}
                    </CardText>
                    <CardText>
                      <strong>Discount Percentage:</strong>{" "}
                      {discount.discountPercentage}%
                    </CardText>
                    <CardText>
                      <strong>Status:</strong>
                      <Badge
                        color={discount.isActive ? "success" : "danger"}
                        className="ms-2"
                      >
                        {discount.isActive ? "Active" : "Inactive"}
                      </Badge>
                    </CardText>
                  </Col>
                </Row>
                {/* Additional Details */}
                <Row className="mt-4">
                  <Col md="6">
                    <CardText>
                      <strong>Category:</strong>
                      <ListGroup className="mt-2">
                        {discount.category.map((cat) => (
                          <ListGroupItem key={cat.id}>
                            {cat.categoryName}
                          </ListGroupItem>
                        ))}
                      </ListGroup>
                    </CardText>
                  </Col>
            
                  <Col md="6">
                    <CardText>
                      <strong>Items:</strong>
                      <ListGroup className="mt-2">
                        {discount.items.map((item) => (
                          <ListGroupItem key={item.id}>
                            {item.itemName}
                            {item.itemPrice && (
                              <span> - Price: {item.itemPrice}</span>
                            )}
                          </ListGroupItem>
                        ))}
                      </ListGroup>
                    </CardText>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
